import { TCollection } from '@/interfaces/collections';
import { TPhoto } from '@/interfaces/photos';
import { formatMediaDownloadName } from '@/utils/formatFileName';
import { clips, packs, social_links } from '@prisma/client';

export const formatCollectionData = (coll: TCollection) => {
  const tempPhotos: TPhoto[] = [];
  const tempMedia: ((TPhoto | packs | social_links | clips) & {
    bookmarkId: number;
    note: string;
  })[] = [];
  coll.bookmarks.forEach((bookmark) => {
    if (bookmark.type === 'photo' && bookmark.photo) {
      tempMedia.push({
        ...bookmark.photo,
        type: 'photo',
        bookmarkId: bookmark.id,
        note: bookmark.note ?? '',
      });
      tempPhotos.push(bookmark.photo);
    }

    if (bookmark.type === 'video' && bookmark.video) {
      tempMedia.push({
        ...bookmark.video,
        type: 'video',
        bookmarkId: bookmark.id,
        note: bookmark.note ?? '',
      });
    }

    if (bookmark.type === 'clip' && bookmark.clip) {
      tempMedia.push({
        ...bookmark.clip,
        type: 'clip',
        bookmarkId: bookmark.id,
        note: bookmark.note ?? '',
      });
    }

    if (bookmark.type === 'link' && bookmark.link) {
      tempMedia.push({
        ...bookmark.link,
        type: 'link',
        bookmarkId: bookmark.id,
        note: bookmark.note ?? '',
      });
    }
  });

  const assetUrls = coll.bookmarks
    .filter((bookmark) => bookmark.type === 'photo' && bookmark.photo?.imgix.links.large_image_url)
    .map((bookmark) => {
      const url = bookmark.photo?.imgix.links.large_image_url!;
      return {
        urls: url,
        fileNames: bookmark.photo?.imgix.downloadName ?? '',
      };
    });

  const zips = coll.bookmarks
    .filter((bookmark) => bookmark.type === 'video' && bookmark.photo?.pack?.zip_file)
    .map((bookmark) => bookmark.photo?.pack!.zip_file!);

  return {
    photos: tempPhotos,
    collectionMedia: tempMedia,
    assetUrls,
    zips,
  };
};

export const getHeroImages = (coll: TCollection | undefined) => {
  return coll?.bookmarks.filter((b) => b.type === 'photo').slice(0, 2);
};
